import UserProfile from "../pages/UserProfile";
import UserProfileFormPage from "../pages/UserProfileFormPage";
import Logout from "../pages/Authentication/Logout";
import DashboardPage from "../pages/Dashboard";
import DevicesPage from "../pages/Devices";
import LandingPage from "../pages/Landing";
import DeviceDetailsPage from "../pages/DeviceDetails";
import UsersPage from "../pages/Users";
import UserDetailsPage from "../pages/UserDetails";
import PageNotFound from "../pages/PageNotFound";
import DeviceWarrantyRegistrationPage from "../pages/DeviceWarrantyRegistrationPage";
import PocMapPage from "../pages/PocMap";
import QuotesPage from "../pages/Quotes";
import QuoteFormPage from "../pages/QuoteFormPage";
import JobFormPage from "../pages/JobFormPage";
import QuoteDetailsPage from "../pages/QuoteDetails";
import JobsPage from "../pages/Jobs";
import JobDetailsPage from "../pages/JobDetails";
import WorkSessionsPage from "../pages/WorkSessions";
import WorkSessionDetailsPage from "../pages/WorkSessionDetails";
import AdminWarrantyRegistrationPage from "../pages/AdminWarrantyRegistrationPage";
import DealerInventoryPage from "../pages/DealerInventoryPage";
import DealerOrdersPage from "../pages/DealerOrdersPage";
import DealerOrderDetailsPage from "../pages/DealerOrderDetailsPage";
import DealerInvoicesPage from "../pages/DealerInvoicesPage";
import DealerInvoiceDetailsPage from "../pages/DealerInvoiceDetailsPage";

import OwnerDashboardWrapper from "../pages/Owner/Dashboard";
import OwnerDevicesPage from "../pages/Owner/Devices";
import DealerDashboardWrapper from "../pages/Dealer/Dashboard";
import DealerDevicesPage from "../pages/Dealer/Devices";

export const pageNotFoundRoute = { path: "*", component: <PageNotFound /> };
const commonAuthProtectedRoutes = [
  { path: "/", component: <LandingPage /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/profile/edit", component: <UserProfileFormPage /> },
  { path: "/poc-map", component: <PocMapPage /> },
  pageNotFoundRoute,
];

const authProtectedRoutesForAdmin = [
  { path: "/dashboard", component: <DashboardPage /> },
  { path: "/machines", component: <DevicesPage /> },
  { path: "/machines/:id", component: <DeviceDetailsPage /> },
  { path: "/users/:id", component: <UserDetailsPage /> },
  { path: "/users", component: <UsersPage /> },
  { path: "/quotes", component: <QuotesPage /> },
  { path: "/quotes/:id", component: <QuoteDetailsPage /> },
  { path: "/quotes/:id/edit", component: <QuoteFormPage /> },
  { path: "/quotes/create", component: <QuoteFormPage /> },
  { path: "/jobs", component: <JobsPage /> },
  { path: "/jobs/:id", component: <JobDetailsPage /> },
  { path: "/jobs/:id/edit", component: <JobFormPage /> },
  { path: "/jobs/create", component: <JobFormPage /> },
  { path: "/work-sessions", component: <WorkSessionsPage /> },
  { path: "/work-sessions/:id", component: <WorkSessionDetailsPage /> },
  { path: "/admin/warranty-registration", component: <AdminWarrantyRegistrationPage /> },
  { path: "/admin/dealer-inventory", component: <DealerInventoryPage /> },
  { path: "/admin/orders/:orderNumber", component: <DealerOrderDetailsPage /> },
  { path: "/admin/orders", component: <DealerOrdersPage /> },
  { path: "/admin/invoices/:invoiceNumber", component: <DealerInvoiceDetailsPage /> },
  { path: "/admin/invoices", component: <DealerInvoicesPage /> },

  ...commonAuthProtectedRoutes,
];

const authProtectedRoutesForUser = [
  { path: "/dashboard", component: <OwnerDashboardWrapper /> },
  { path: "/quotes", component: <QuotesPage /> },
  { path: "/quotes/:id", component: <QuoteDetailsPage /> },
  { path: "/quotes/:id/edit", component: <QuoteFormPage /> },
  { path: "/quotes/create", component: <QuoteFormPage /> },
  { path: "/jobs", component: <JobsPage /> },
  { path: "/jobs/:id", component: <JobDetailsPage /> },
  { path: "/jobs/:id/edit", component: <JobFormPage /> },
  { path: "/jobs/create", component: <JobFormPage /> },
  { path: "/machines", component: <OwnerDevicesPage /> },
  { path: "/machines/:id", component: <DeviceDetailsPage /> },
  { path: "/machines/:id/warranty-registration", component: <DeviceWarrantyRegistrationPage /> },
  { path: "/dashboard/:id/warranty-registration", component: <DeviceWarrantyRegistrationPage /> },
  ...commonAuthProtectedRoutes,
];

const authProtectedRoutesForDealer = [
  { path: "/dashboard", component: <DealerDashboardWrapper /> },
  { path: "/machines", component: <DealerDevicesPage /> },
  { path: "/machines/:id", component: <DeviceDetailsPage /> },
  { path: "/admin/warranty-registration", component: <AdminWarrantyRegistrationPage /> },
  ...commonAuthProtectedRoutes,
];

const authProtectedRoutesForUnregistered = [
  pageNotFoundRoute,
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
];

export {
  authProtectedRoutesForAdmin,
  authProtectedRoutesForUser,
  authProtectedRoutesForDealer,
  authProtectedRoutesForUnregistered,
  publicRoutes,
};
